<template>
  <div class="mt-3 mx-3">
    <v-card class="pa-3 rounded-lg"
      :style="{ backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg-lhp)' : 'var(--light-bg-lhp)' }">
      <v-row>
        <v-col cols="12">
          <div class="pa-3">
            <span class="text-subtitle-2 font-weight-bold align-center">Grafik Petugas</span>
          </div>
        </v-col>
      </v-row>
      <v-divider class="mx-3" />
      <div class="chart-container mx-3">
        <div class="chart-wrapper">
          <div v-if="loading" class="d-flex justify-center align-center" style="height: 300px;">
            <v-progress-circular indeterminate color="primary" size="40" />
          </div>
          <canvas v-else ref="chartPetugasCanvas"></canvas>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Chart from "chart.js";
import services from "@/services";

export default {
  props: {
    chartType: {
      type: String,
      default: "bar",
    },
  },
  data() {
    return {
      loading: true,
      chartInstancePetugas: null,
      chartDataPetugas: {
        labels: [],
        datasets: [
          {
            label: "Menagih",
            backgroundColor: "#520e63",
            data: [],
          },
          {
            label: "Tertagih",
            backgroundColor: "#27445D",
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                fontSize: 10, // ukuran font label X
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 10, // ukuran font label Y
                callback: function (value) {
                  return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0
                  }).format(value);
                },
              },
            },
          ],
        },
        tooltips: {
          bodyFontSize: 10, // ukuran font isi tooltip
          titleFontSize: 10, // ukuran font judul tooltip
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label || "";
              const value = tooltipItem.yLabel;
              const formatted = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0
              }).format(value);
              return `${label}: ${formatted}`;
            },
          },
        },
        legend: {
          labels: {
            fontSize: 10, // ukuran font legenda
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    this.fetchChartDataPetugas();
  },
  methods: {
    async fetchChartDataPetugas() {
      this.loading = true;
      try {
        const payload = new FormData();
        payload.append("branch_code", this.user.branch_code);

        const response = await services.grafikPetugas(payload);

        if (response.data && response.data.status && response.data.data) {
          const { menagih = [], tertagih = [] } = response.data.data;
          const labels = menagih.map((item) => String(item.petugas));
          const menagihValues = menagih.map((item) => Number(item.nominal) || 0);
          const tertagihValues = tertagih.map((item) => Number(item.nominal) || 0);

          // Update chart data
          this.chartDataPetugas.labels = labels;
          this.chartDataPetugas.datasets[0].data = menagihValues;
          this.chartDataPetugas.datasets[1].data = tertagihValues;

          this.loading = false;

          this.$nextTick(() => {
            this.renderChartPetugas();
          });
        } else {
          console.error("Status API false atau format data tidak sesuai:", response.data);
          this.loading = false;
        }
      } catch (error) {
        console.error("Fetch chart error:", error);
        this.loading = false;
      }
    },
    renderChartPetugas() {
      if (this.chartInstancePetugas) {
        this.chartInstancePetugas.destroy();
      }

      const canvas = this.$refs.chartPetugasCanvas;
      if (!canvas) {
        // console.warn("Canvas not found");
        return;
      }

      const ctx = canvas.getContext("2d");

      this.chartInstancePetugas = new Chart(ctx, {
        type: this.chartType,
        data: this.chartDataPetugas,
        options: this.chartOptions,
      });
    },
  },
  beforeDestroy() {
    if (this.chartInstancePetugas) {
      this.chartInstancePetugas.destroy();
    }
  },
};
</script>

<style scoped>
.chart-container {
  overflow-x: auto;
}

.chart-wrapper {
  min-width: 800px;
  height: 300px;
}
</style>
